import React from 'react';

import PropTypes from 'prop-types';

import {
    Control,
    SplitTest,
    Variant,
} from 'wanderu-component-split-test';
import {
    MarkdownContent,
    Typography,
    Section,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import CarrierStatsTable from '../CarrierStatsTable/CarrierStatsTable';
import CarrierList from './CarrierList';

import styles from './CarrierSection.scss';

const removeCarriersWithoutCardText = ({ namespace, carriers, t }) => {
    return carriers.reduce((carrierList, carrier) => {
        const { carrierCode } = carrier;
        const carrierCardTextKey = `${carrierCode}_carrierCardText${carrierCode}`;
        const carrierCardLabelKey = `${carrierCode}_carrierCardLabel`;

        const hasText = t(`${namespace}:${carrierCardTextKey}`) !== carrierCardTextKey
            && !!t(`${namespace}:${carrierCardTextKey}`).length;
        const hasLabel = t(`${namespace}:${carrierCardLabelKey}`) !== carrierCardLabelKey
            && !!t(`${namespace}:${carrierCardLabelKey}`).length;

        if (hasText && hasLabel) {
            return [
                ...carrierList,
                carrier,
            ];
        }

        return carrierList;
    }, []);
};

function CarrierSection(props) {
    const {
        t,
        data,
        namespace,
        title,
        description,
        subheading,
        hideCarrierStatsTable,
    } = props;

    const carrierList = removeCarriersWithoutCardText({ namespace, carriers: data, t });

    return (
        <Section id="carrier-section">
            <Typography
                classes={{ root: styles.heading }}
                variant="h3"
            >
                {title}
            </Typography>
            <Typography
                className={styles.description}
                component={MarkdownContent}
                paragraph
            >
                {description}
            </Typography>
            {!!subheading && !hideCarrierStatsTable && (
                <Typography
                    className={styles.subheading}
                    component="h3"
                    variant="subtitle"
                >
                    {subheading}
                </Typography>
            )}
            {!hideCarrierStatsTable && (
                <CarrierStatsTable
                    carrierData={data}
                    namespace={namespace}
                />
            )}
            {!!carrierList.length && (
                <SplitTest testName="CarrierDetailsDeduplication">
                    <Control>
                        <CarrierList
                            data={carrierList}
                            namespace={namespace}
                        />
                    </Control>
                    <Variant name="hidden">
                        {/* Hide content deliberately */}
                    </Variant>
                </SplitTest>
            )}
        </Section>
    );
}

CarrierSection.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    subheading: PropTypes.string,
    namespace: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    hideCarrierStatsTable: PropTypes.bool,
};
CarrierSection.defaultProps = {
    data: [],
    subheading: '',
    hideCarrierStatsTable: false,
};

export { CarrierSection };
export default localize(CarrierSection);
